import { types } from 'mobx-state-tree'

import {
  Auth,
  Account,
  AccountInsight,
  Accounts,
  Breakdown,
  Chat,
  Config,
  CommunicationPreferences,
  Person,
  Spouse,
  Dependents,
  ContactInfo,
  Documents,
  Engine,
  Features,
  Goals,
  InvestmentUpload,
  Login,
  StockOptions,
  UserLogs,
  Toast,
  UserSettings,
  PortfolioConstruction,
  Plaid,
  Plan,
  SpendDown,
  SocialSecurity,
  RetailStore,
  CatchupRules,
} from './models'

const { compose } = types

const AppStore = compose(
  Auth,
  Account,
  AccountInsight,
  Accounts,
  Breakdown,
  CatchupRules,
  Chat,
  Config,
  CommunicationPreferences,
  Person,
  Spouse,
  Dependents,
  ContactInfo,
  Documents,
  Engine,
  Features,
  Goals,
  InvestmentUpload,
  Login,
  StockOptions,
  UserLogs,
  Toast,
  UserSettings,
  PortfolioConstruction,
  Plaid,
  Plan,
  SpendDown,
  SocialSecurity,
  RetailStore
)

export default AppStore
